import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';
import { Travel } from 'src/app/models/travel';
import { travelAuthorUrl } from 'src/app/modules/shared/common/api';

@Component({
  selector: 'app-travel-cash-approve-list',
  templateUrl: './travel-cash-approve-list.component.html',
  styleUrls: ['./travel-cash-approve-list.component.scss']
})
export class TravelCashApproveListComponent implements OnInit {

  keyWords = [];
  isNoResult: boolean = false;
  loading:boolean = false;
  isKeyWord:boolean = false;
  keyTable = '';

  totalRec : number;
  page: number = 1;
  perPage: number;

  travel: any;
  dialogConfig:any;
  formGroup: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<TravelCashApproveListComponent>,
    public travelService: TravelService
  ) { }

  ngOnInit() {
    this.getList();
  }

  getSelect(res){
    this.dialogRef.close(res);
  }

  getList() {
    let param = [];
    let queryString = '';

    param.push('type=for-cash-advance');

    if (this.page) {
      param.push('page='+this.page);
    }
  
    if (param.length) {
      queryString = '?' + param.join('&');
    }

    this.loading = true;
    this.isNoResult = false;
    this.travelService.url = travelAuthorUrl+'/lookup'+ queryString;
    this.travelService.getFilter().subscribe(res=>{
      if (res.data.length) {
        this.travel = new Travel(res.data);
      }
      this.totalRec = res.total;
      this.perPage = res.per_page;
      this.loading = false;
      if (res.total == 0) {
        this.isNoResult = true;
      }
    });
  }

  closeOnClick() {
    this.dialogRef.close('');
  }

  pageChange(newPage: number) {
    this.page = newPage;
    this.getList();
		return false;
  }

}
